import { Fragment } from "react";
import styled from "styled-components";
import {
  Divider,
  MenuItem as MuiMenuItem,
  Checkbox as MuiCheckbox,
  Typography,
} from "@mui/material";
import { CheckBoxOutlineBlank, CheckBoxOutlined } from "@mui/icons-material";
import { colors } from "../../../css components/Style";

// Styled MenuItem
const MenuItem = styled(MuiMenuItem)`
  min-width: 200px;
  height: 30px;
  &:hover {
    box-shadow: none;
    background-color: transparent; /* optional: remove hover bg */
  }
`;

// Styled Checkbox
const Checkbox = styled(MuiCheckbox)`
  &:hover {
    background-color: transparent; /* removes ripple/hover bg */
    box-shadow: none;
  }
`;

export default function DropDownMenu({
  setFields,
  channel,
  fields,
  setMenuAnchor,
}) {
  return (
    <>
      {fields[channel]?.map((field, i) => (
        <Fragment key={i}>
          <MenuItem disableRipple>
            <Checkbox
              name={field.name}
              onChange={(e) => {
                let vals = { ...fields };
                for (let val of vals[channel]) {
                  if (val.name === e.target.name) {
                    val.display = e.target.checked;
                  }
                }
                setFields(vals);
              }}
              checked={field.display}
              icon={<CheckBoxOutlineBlank fontSize="small" />}
              checkedIcon={
                <CheckBoxOutlined
                  fontSize="small"
                  sx={{ color: colors.error }}
                />
              }
              sx={{ p: 0, pr: 1 }}
            />
            <Typography>{field.name}</Typography>
          </MenuItem>
          {i !== fields[channel].length - 1 && <Divider sx={{ my: "7px" }} />}
        </Fragment>
      ))}
    </>
  );
}
